export default __webpack_public_path__ + "static/media/kamados.3b650e63.svg";